<template>
    <div class="spinner">
        <div class="spinner__loader">
            <svg class="spinner__circular" viewBox="25 25 50 50">
                <circle class="spinner__path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="40" />
            </svg>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    data(): any {
        return {
            loading: true as boolean,
        }
    },

    mounted(): void {
        this.loading = false
    },
}
</script>

<style lang="scss" scoped>
.spinner {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 50vh 0 0;
    z-index: 9999;

    &--relative {
        position: relative;
        padding: 0;
    }

    &--visible {
        display: block;
    }

    &__loader {
        position: relative;
        margin: 0 auto;
        width: $loader-size;
        height: $loader-size;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 5px;

        &::before {
            content: '';
            display: block;
            padding-top: 100%;
            background: url('/nuxt-assets/icons/krizos.svg') no-repeat center center;
        }
    }

    &__circular {
        animation: rotate 1s linear infinite;
        height: 100%;
        transform-origin: center center;
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        padding: 5px;
    }

    &__path {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
        animation: dash 1.5s ease-in-out infinite;
        stroke-linecap: round;
        stroke: $color-white;
    }
}

body.loader {
    .spinner:not(.spinner--body-independent) {
        display: block;
    }
}

// Preload spinner
.spinner-vue {
    position: relative;
    overflow: hidden;
    height: 500px;

    &::before {
        position: absolute;
        width: 100%;
        height: 100%;
        background: $color-white;
        content: '';
        left: 0;
        z-index: 10;
        top: 0;
    }

    &::after {
        position: absolute;
        width: 100px;
        height: 100px;
        margin: 100px auto;
        background-color: $color-cta;
        border-radius: 100%;
        animation: sk-scaleout 1000ms infinite ease-in-out;
        z-index: 11;
        content: '';
        left: calc(50% - 50px);
        top: 40px;
    }
}
</style>
